import { useMemo } from "react";
import * as olProj from "ol/proj";
import ConstrainedView from "../../components/reactOL/views/ConstrainedView";
import { useOlMap } from "../../components/reactOL/hooks/useOlMap";
import { MapContext } from "./MapContext";

interface ViewProviderProps {
  children: React.ReactNode;
}

export const MapProvider = ({ children }: ViewProviderProps) => {
  const projection = useMemo(() => olProj.get("EPSG:3857")!, []);

  const view = useMemo(
    () =>
      new ConstrainedView({
        center: [-222638, 7170156],
        zoom: 1,
        projection,
        minZoom: 5,
        maxZoom: 10,
      }),
    [projection],
  );

  const { map, mapRef } = useOlMap({ view });

  return (
    <MapContext.Provider value={{ map, mapRef }}>
      {children}
    </MapContext.Provider>
  );
};
